module.exports = __webpack_public_path__ + "img/layout_cols.a17cad44.png";